/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Desc_NoteInputs */

const vi_shop_desc_note = /** @type {(inputs: Shop_Desc_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện ở tab "Thông tin" của trang sản phẩm trên website và Mini App. Ảnh tải lên lưu trên ERP; định dạng không hỗ trợ sẽ được lọc bỏ khi lưu.`)
};

/**

* @param {Shop_Desc_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_desc_note = /** @type {((inputs?: Shop_Desc_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Desc_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_desc_note(inputs)
});